import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "business-rule-view",
  templateUrl: "./business-rule-view.component.html",
  styleUrls: ["./business-rule-view.component.scss"],
})
export class BusinessRuleViewComponent implements OnInit {
  form: FormGroup;
  id: string | null = null;
  matchingRule: any;
  mode: "create" | "edit";
  initialFormValues: any;
  constructor(private route: ActivatedRoute, private fb: FormBuilder) {}

  ruleLangs = ["Schematron"];

  statusOptions = [
    "ToDo",
    "Proposed",
    "Work in progress",
    "Done",
    "InUse",
    "Rejected",
  ];

  rules = [
    {
      id: 1,
      title: "Rule 1",
      description: "Property X must exist",
      ruleText: "exist(aixm:x)",
      status: "Done",
    },
    {
      id: 2,
      title: "Rule 2",
      description: "Property Y must have value between 10 and 20",
      ruleText: "between10and20(aixm:y)",
      status: "InUse",
    },
    {
      id: 3,
      title: "Feature:DesignatedPoint",
      description:
        "DesignatedPoint must have either property X or Y but not both.",
      ruleText: "oneOf(aixm:x,aixm:y)",
      status: "InUse",
    },
    {
      id: 4,
      title: "Group:PointType",
      description: "Property group PointType must have both properties X and Y",
      ruleText: "both(aixm:x,aixm:y)",
      status: "Rejected",
    },
    {
      id: 5,
      title: "Property:DesignatedPointPropertyGroup.type",
      description: "DesignatedPoint type may not have values A or B",
      ruleText: "optional(aixm:a,aixm:b)",
      status: "ToDo",
    },
  ];

  resetFields(): void {
    this.form.reset(this.initialFormValues);
  }
  //   resetFields(): void {
  //     if (this.mode === "edit") {
  //       this.form.reset(this.initialFormValues);
  //     }
  //   }
  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("ruleId");

    const match = this.rules?.find((el) => el?.id?.toString() === this.id);

    if (this.id === "create") {
      this.mode = "create";
      this.form = this.fb.group({
        ruleName: [
          null,
          [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(255),
          ],
        ],
        description: [null],
        diagnostic: [null, Validators.required],
        suggestion: [null],
        ruleLang: [
          { value: "Schematron", disabled: true },
          Validators.required,
        ],
        context: [null, Validators.required],
        ruleText: [null, Validators.required],
        mode: ["Assert", Validators.required],
        status: ["Work in progress", Validators.required],
        aixmClass: [null],
        aixmAttribute: [null],
      });
    }

    if (match) {
      this.mode = "edit";
      this.matchingRule = match;
      this.form = this.fb.group({
        identifier: [{ value: match.id, disabled: true }],
        ruleName: [
          match.title,
          [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(255),
          ],
        ],
        description: [match.description],
        diagnostic: [null, Validators.required],
        suggestion: [null],
        ruleLang: [
          { value: "Schematron", disabled: true },
          Validators.required,
        ],
        context: [null, Validators.required],
        ruleText: [match.ruleText, Validators.required],
        mode: ["Assert", Validators.required],
        status: [match.status, Validators.required],
        aixmClass: [null],
        aixmAttribute: [null],
      });
    }

    this.initialFormValues = this.form.getRawValue();
  }
}
